export const DocIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_198_3504)">
      <path
        d="M16.0002 4.275H3.7002V1.2875C3.7002 0.8875 4.0252 0.5625 4.4252 0.5625H15.2627C15.6627 0.5625 15.9877 0.8875 15.9877 1.2875V4.275H16.0002Z"
        fill="#41A5ED"
      />
      <path
        d="M16.0002 4.27502H3.7002V8.00002H16.0002V4.27502Z"
        fill="#2C7BD5"
      />
      <path d="M16.0002 8H3.7002V11.725H16.0002V8Z" fill="#195ABE" />
      <path
        d="M15.2754 15.4375H4.43789C4.03789 15.4375 3.71289 15.1125 3.71289 14.7125V11.725H16.0004V14.7125C16.0004 15.1125 15.6754 15.4375 15.2754 15.4375Z"
        fill="#103E91"
      />
      <path
        d="M7.4377 12.0625H0.812695C0.375195 12.0625 0.0126953 11.7 0.0126953 11.2625V4.7375C0.0126953 4.3 0.375195 3.9375 0.812695 3.9375H7.4377C7.8752 3.9375 8.2377 4.3 8.2377 4.7375V11.2625C8.2377 11.7 7.8877 12.0625 7.4377 12.0625Z"
        fill="#2166C3"
      />
      <path
        d="M2.4123 10.3L1.2998 5.8125H2.1873L2.6248 7.85C2.7373 8.4 2.8498 8.9625 2.9248 9.4125H2.9373C3.0123 8.9375 3.1373 8.4125 3.2623 7.8375L3.7498 5.8125H4.6248L5.0748 7.875C5.1873 8.4125 5.2873 8.9 5.3498 9.3875H5.3623C5.4373 8.8875 5.5498 8.3875 5.6748 7.8375L6.1498 5.8125H6.9998L5.7748 10.3H4.8748L4.3998 8.1875C4.2873 7.6875 4.1998 7.2625 4.1373 6.775H4.1248C4.0498 7.25 3.9623 7.6875 3.8248 8.2L3.2998 10.3125H2.4123V10.3Z"
        fill="white"
      />
      <path
        opacity="0.2"
        d="M8.23789 4.66248C8.23789 4.68748 8.23789 4.71248 8.23789 4.73748V11.2625C8.23789 11.7 7.87539 12.0625 7.43789 12.0625H3.71289V12.775H8.11289C8.55039 12.775 8.91289 12.4125 8.91289 11.975V5.44998C8.91289 5.04998 8.62539 4.71248 8.23789 4.66248Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_198_3504">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
